import { FC, useMemo, useEffect, useState } from 'react';
import { IPopupWrapper } from '../../../../../../../../shared/components/popup/components/popup.component.tsx';
import {
  IStepper,
  Stepper,
} from '../../../../../../../../shared/components/stepper/stepper.component.tsx';
import { FirstStep } from './steps/firstStep.tsx';
import { SecondStep } from './steps/secondStep.tsx';
import { Content as Wrapper } from '../../../../../../../../shared/components/content/content.component.tsx';
import {
  configurationService,
  ListPriceCategoriesMappingBetweenWaAndCaQueryRes,
  ListArticleNumberDuplicatesFromCaQueryRes,
} from '../../../../../services/configuration.service.ts';
import {
  configsData,
  DictPriceCategoriesRes,
} from '../../../../../../../../shared/services/configsData/configsData.service.ts';
import { zipWith, take } from 'rxjs';
import { responseHandler } from '../../../../../../../../shared/responseHandler/responseHandler.ts';
import { ThirdStep } from './steps/thirdStep.tsx';
import {
  reimportArticlesFromCAState,
  IReimportArticlesFromCA,
} from './states/reimportArticlesFromCA.state.ts';

export const ContentPopup: FC<IContentPopup> = () => {
  const [secondStepData, setSecondStepData] = useState<ISecondStepData>({
    listPriceCategoriesMappingBetweenWAAndCA: [],
    priceCategories: [],
  });
  const [thirdStepData, setThirdStepData] = useState<IThirdStepData>({
    reimportResult: {},
  });
  useEffect(() => {
    const configurationServiceSub = configurationService.sub
      .listArticleNumberDuplicatesFromCA()
      .pipe(
        responseHandler<ListArticleNumberDuplicatesFromCaQueryRes>({
          errorReturnType: [],
        }),
        take(1),
        zipWith(
          configsData.sub.dictPriceCategories(),
          configurationService.sub.listPriceCategoriesMappingBetweenWAAndCA().pipe(
            responseHandler<ListPriceCategoriesMappingBetweenWaAndCaQueryRes>({
              errorReturnType: [],
            }),
          ),
        ),
      )
      .subscribe((data) => {
        setSecondStepData({
          priceCategories: data[1],
          listPriceCategoriesMappingBetweenWAAndCA: data[2],
        });
        reimportArticlesFromCAState.pub.init({ listArticleNumberDuplicatesFromCA: data[0] });
      });
    configurationService.pub.listPriceCategoriesMappingBetweenWAAndCA();
    configurationService.pub.listArticleNumberDuplicatesFromCA();
    configsData.pub.common(['dictPriceCategories']);
    const reimportArticlesFromCAStateSub = reimportArticlesFromCAState.sub
      .state()
      .subscribe(({ action, ...state }) => {
        if (action === 'saveData') {
          setThirdStepData({ reimportResult: state.reimportResult });
        }
      });
    return () => {
      configurationServiceSub.unsubscribe();
      reimportArticlesFromCAStateSub.unsubscribe();
    };
  }, []);
  const steps: IStepper['steps'] = useMemo(
    () => [
      {
        Component: <FirstStep />,
      },
      {
        Component: <SecondStep {...{ secondStepData }} />,
      },
      {
        Component: <ThirdStep {...{ thirdStepData }} />,
      },
    ],
    [secondStepData, thirdStepData],
  );
  return (
    <Wrapper type='stack'>
      <Stepper {...{ steps }} visibleDefaultControls={false} />
    </Wrapper>
  );
};

interface IContentPopup {
  stream: IPopupWrapper['stream'];
}

export interface ISecondStepData {
  listPriceCategoriesMappingBetweenWAAndCA: ListPriceCategoriesMappingBetweenWaAndCaQueryRes;
  priceCategories: DictPriceCategoriesRes;
}
export interface IThirdStepData {
  reimportResult: IReimportArticlesFromCA['reimportResult'];
}
